import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { serviceWithoutActRequestCRUD } from "../../../../http/CRUD";
import CRUDTable from "../../CRUDTable";
import {
  contractRequestFilterFields,
  contractRequestSearchFields
} from "../../../../sections/Filters/ContractRequestFilter";
import {columnsRequest} from "../../../../sections/Columns/RequestColumns";
import {useTranslation} from "react-i18next";
import { requestStateIds } from "../../../../models/requestStateIds";
import useReload from "../../../../hooks/useReload";
import { appendRequestRollbackColumn } from "../../requestRollbackColumn";

export const ServiceWithoutActRequestCRUDTable = (props) => {
  const { push } = useHistory();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { reload, reloadValue: localReloadValue } = useReload();

  const searchFields = [
    ...contractRequestSearchFields,
  ];

  const filterFields = [
    ...contractRequestFilterFields
  ];

  const columns = appendRequestRollbackColumn([...columnsRequest(t)], serviceWithoutActRequestCRUD, {
    reload,
  });

  return (
    <CRUDTable
      search={serviceWithoutActRequestCRUD.search}
      columns={columns}
      filterFields={filterFields}
      searchFields={searchFields}
      onClickDetailsButton={( id ) => {
        push(`${pathname}/${id}`)
      }}
      reloadValue={props.reloadValue ?? localReloadValue}
      rowClassNameHandler={(record) => {
        if (record.stateId === requestStateIds.declined) {
          return 'banned'
        }
      }}
      {...props}
    />
  );
};
